import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import * as CanvasJS from './canvasjs.min.js';

import { Authenticationservice } from '../core/services/authentication.service';
import axios from 'axios';

@Component({
  selector: 'app-supporter',
  templateUrl: './supporter.component.html',
  styleUrls: ['./supporter.component.css']
})
export class SupporterComponent implements OnInit, OnDestroy {
  /// Valiable ///
  level;
  home = 3;
  Timecheck: UntypedFormGroup;
  code;
  chart;
  manager = false;
  grade: any[];

  maindata: any[];
  allbrd;
  color = false;
  selectzone = [
      { zonecode: '' },
      { zonecode: '01' },
      { zonecode: '02' },
      { zonecode: '02.1' },
      { zonecode: '03.1' },
      { zonecode: '03.2' },
      { zonecode: '04' },
      { zonecode: '05' },
      { zonecode: '06.1' },
      { zonecode: '06.2' },
      { zonecode: '07.1' },
      { zonecode: '07.2' },
      { zonecode: '08.1' },
      { zonecode: '08.2' },
      { zonecode: '09' },
      { zonecode: '09.1' },
      { zonecode: '10.1' },
      { zonecode: '10.2' },
      { zonecode: 'all' }
  ];

  /// End ////
  constructor(private router: Router, private spinner: NgxSpinnerService,private auth: Authenticationservice) {
    if (localStorage.getItem('userdata') === null || localStorage.getItem('userdata') === undefined) {
      this.router.navigateByUrl('/loign');
    }
    else {
      this.lebdata = this.auth.Authention();
      this.code = this.lebdata.supcode;
      this.level = this.lebdata.userlevel
      this.Allchart();
      if (this.code !== '923') {
        this.manager = true;
      }
    }

    this.Timecheck = new UntypedFormGroup({
      selettime: new UntypedFormControl(Validators.required),
      seletzone: new UntypedFormControl(),
    });
  }

  lebdata;
  ngOnInit(): void {
  }

  // สลับแทบ
  check(x) {
    if (x == 0) {
      this.home = 0;
    }
    else if (x == 1) {
      this.home = 1;
    }    
    else if (x == 2) {
      this.home = 2;
    }
    else if (x == 3) {
      this.home = 3;
    }
  }

  // กราฟแสดงผล
  Allchart() {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/targetArea6465';
    fetch(url)
      .then(res => res.json())
      .then((out: any) => {
        const data = out.recordsets[0];
        let chartbrd = data.filter(element => element.Partcode == "BRD")
        let BRDArea = new CanvasJS.Chart("BRDArea", {
          theme: "light2",
          animationEnabled: true,
          exportEnabled: true,

          title: {
            fontSize: 20,
            labelTextAlign: "center",
            fontFamily: "Sarabun, sans-serif",
            text: "กราฟแสดงพื้นที่ปลูกอ้อย โดยรวม BRD",
          },
          data: [{
            type: "doughnut",
            showInLegend: true,
            fontFamily: "Sarabun, sans-serif",
            toolTipContent: "<b>{name}</b>: {y} (#percent%)",
            indexLabel: "{name} - #percent%",
            dataPoints: [
              { y: chartbrd[0].pc_target_areas, name: "พื้นที่ปลูกทั้งหมด", color: "#43AA8B" },
              { y: 100 - chartbrd[0].pc_target_areas, name: "พื้นที่ปลูกที่ขาด", color: "#FF3333" },
            ]
          }]
        });

        let BRDTon = new CanvasJS.Chart("BRDTon", {
          theme: "light2",
          animationEnabled: true,
          exportEnabled: true,

          title: {
            fontSize: 20,
            labelTextAlign: "center",
            fontFamily: "Sarabun, sans-serif",
            text: "กราฟแสดงประเมินอ้อย โดยรวม BRD",
          },
          data: [{
            type: "doughnut",
            showInLegend: true,
            fontFamily: "Sarabun, sans-serif",
            toolTipContent: "<b>{name}</b>: {y} (#percent%)",
            indexLabel: "{name} - #percent%",
            dataPoints: [
              { y: chartbrd[0].pc_target_ton, name: "ประเมินอ้อยทั้งหมด", color: "#43AA8B" },
              { y: 100 - chartbrd[0].pc_target_ton, name: "ประเมินอ้อยที่ขาด", color: "#FF3333" },
            ]
          }]
        });
        let BRDYield = new CanvasJS.Chart("BRDYield", {
          theme: "light2",
          animationEnabled: true,
          exportEnabled: true,

          title: {
            fontSize: 20,
            labelTextAlign: "center",
            fontFamily: "Sarabun, sans-serif",
            text: "กราฟแสดงค่า Yield อ้อย โดยรวม BRD",

          },
          data: [{
            type: "doughnut",
            showInLegend: true,
            fontFamily: "Sarabun, sans-serif",
            toolTipContent: "<b>{name}</b>: {y} (#percent%)",
            indexLabel: "{name} - #percent%",
            dataPoints: [
              { y: chartbrd[0].pc_target_yield, name: "Yield ทั้งหมด", color: "#43AA8B" },
              { y: 100 - chartbrd[0].pc_target_yield, name: "Yield ที่ขาด", color: "#FF3333" },

            ]
          }]
        });
        BRDArea.render();
        BRDTon.render();
        BRDYield.render();
      })
      .catch(err => { throw err });
  }


  /// พื้นที่ปลูก
  Maindashboard() {
    let time = (new Date(this.Timecheck.get('selettime').value).getTime() / 1000);
    let zone = this.Timecheck.get('seletzone').value;
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/informarea6465ByDate?lastdate=' + time;
    this.spinner.show();
    axios.get(url)
      .then((out: any) => {
        const data = out.data.recordsets[0];
        if (data.length == 0) { alert('ไม่มีข้อมูลวันที่ดังกล่าว'); }
        else {
          let allbrd = data;
          if (zone != 'all'){
            let zonebrd = data.filter(element => element.SUPZONE.trim() === zone)
            if (zone == null || zone == '') { this.maindata = allbrd; }
            else { this.maindata = zonebrd; }
          }
          else {
            this.maindata = data.filter(element => element.supcode.trim() === 'Z');
          }
          this.maindata = this.maindata.sort((a:any, b:any) => b.Partcode.localeCompare(a.Partcode));
        }
      })
      .catch(err => { throw err });
      this.spinner.hide();    
  }

  // ข้อมูลปี 6566 
  data6566=[];
  LoadData6566(){
    let time = (new Date(this.Timecheck.get('selettime').value).getTime() / 1000);
    let zone = this.Timecheck.get('seletzone').value;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/informarea6566ByDate?lastdate="+time;
    axios.get(url)
    .then((out: any) => {
      this.spinner.show();
      const data = out.data.recordsets[0];
      if (data.length == 0) { alert('ไม่มีข้อมูลวันที่ดังกล่าว'); }
      else {
        let allbrd = data;
        if (zone != 'all'){
          let zonebrd = data.filter(element => element.SUPZONE.trim() === zone);
          if (zone == null || zone == '') 
          { this.data6566 = allbrd; }
          else { this.data6566 = zonebrd;}
        }
        else {
          this.data6566 = data.filter(element => element.supcode.trim() === 'Z');
        }
      }
      this.data6566 = this.data6566.sort((a:any, b:any) => b.Partcode.localeCompare(a.Partcode));
      this.spinner.hide();

    })
    .catch(err => { throw err });
  }

  data6667=[];
  LoadData6667(){
    let time = (new Date(this.Timecheck.get('selettime').value).getTime() / 1000);
    let zone = this.Timecheck.get('seletzone').value;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/informarea6667ByDate?lastdate="+time;
    axios.get(url)
    .then((out: any) => {
      this.spinner.show();
      const data = out.data;
      if (data.length == 0) { alert('ไม่มีข้อมูลวันที่ดังกล่าว'); }
      else {
        let allbrd = data;
        if (zone != 'all'){
          let zonebrd = data.filter(element => element.SUPZONE.trim() === zone);
          if (zone == null || zone == '') 
          { this.data6667 = allbrd; }
          else { this.data6667 = zonebrd;}
        }
        else {
          this.data6667 = data.filter(element => element.supcode.trim() === 'Z');
        }
      }
      this.data6667 = this.data6667.sort((a:any, b:any) => b.Partcode.localeCompare(a.Partcode));
      this.spinner.hide();

    })
    .catch(err => { throw err });
  }

  Printdata() {
    window.print()
  }

  ngOnDestroy(): void {
    this.maindata = null;
    this.data6566 = null;
    setTimeout(() => {
      localStorage.removeItem('userdata');
      localStorage.clear();
      this.router.navigateByUrl("/login");
    }, 3600000);
  }
}